import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import Column from "@amzn/meridian/column";
import Divider from "@amzn/meridian/divider";
import Row from "@amzn/meridian/row";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getGroundTruthData,
  getGroundTruthDataListView,
  updateColumnVisibilityFromModelMetadata,
} from "src/store/modelLifeCycleGroundTruthSlice";
import { setSelectedModelId } from "src/store/modelManagementSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import ReviewHeader from "src/components/shared/groundTruth/reviewHeader/reviewHeader";
import ReviewTable from "src/components/shared/groundTruth/reviewTable/reviewTable";
import ReviewText from "src/components/shared/groundTruth/reviewText/reviewText";
import "./modelGroundTruthReview.scss";
import {
  usePostUpdateNavigation,
  useGroundTruthDataEffects,
  useListViewEffects,
  useNavigationHandlers,
  useSaveHandler,
} from "src/components/shared/groundTruth/groundTruthReviewUtils";

const ModelGroundTruthReview = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { token } = useAppSelector((state) => state.user);
  const { getListViewLoading, getGroundTruthDataLoading } = useAppSelector(
    (state) => state.modelLifeCycleGroundTruthSlice,
  );
  const { selectedModel } = useAppSelector((state) => state.modelSlice);
  const { modelId, sourceId } = useParams();

  useEffect(() => {
    if (token && modelId && sourceId) {
      dispatch(getGroundTruthData({ modelId: modelId, sourceId: sourceId }));
    }
  }, [modelId, sourceId, token]);

  useEffect(() => {
    if (token && modelId && getListViewLoading === "idle") {
      dispatch(getGroundTruthDataListView(modelId));
    }
  }, [modelId, token, getListViewLoading]);

  useEffect(() => {
    if (modelId) {
      dispatch(setSelectedModelId(modelId));
    }
  }, [modelId]);

  useEffect(() => {
    if (getListViewLoading === "rejected") {
      navigate(`/validationWorkflow/${modelId}`);
    }
  }, [getListViewLoading]);

  // Update column visibility when both ground truth data and model metadata are available
  useEffect(() => {
    if (
      getGroundTruthDataLoading === "fulfilled" &&
      selectedModel.id &&
      selectedModel.metadata !== undefined
    ) {
      dispatch(
        updateColumnVisibilityFromModelMetadata({
          modelMetadata: selectedModel.metadata,
        }),
      );
    }
  }, [getGroundTruthDataLoading, selectedModel.id, selectedModel.metadata, dispatch]);

  usePostUpdateNavigation("validationWorkflow", sourceId, modelId);
  useGroundTruthDataEffects();
  useListViewEffects(sourceId);

  const { onLeftChevronClick, onRightChevronClick } = useNavigationHandlers(
    "validationWorkflow",
    modelId,
  );
  const { onSaveClick } = useSaveHandler();

  return (
    <Column spacingInset={"500 400 0 400"} spacing={"none"}>
      <BreadcrumbGroup>
        <Breadcrumb onClick={() => navigate(`/validationWorkflow`)}>Validation workflow</Breadcrumb>
        <Breadcrumb onClick={() => navigate(`/validationWorkflow/${modelId}`)}>
          {selectedModel.name} - Processed
        </Breadcrumb>
        <Breadcrumb>{sourceId}</Breadcrumb>
      </BreadcrumbGroup>
      {modelId && (
        <ReviewHeader
          onLeftChevronClick={onLeftChevronClick}
          onRightChevronClick={onRightChevronClick}
          onSaveClick={onSaveClick}
          showMoveToNextToggle={true}
        />
      )}
      <Divider></Divider>
      <Row
        spacingInset={"0"}
        widths={["35%", "fit", "fill"]}
        alignmentVertical="top"
        spacing={"none"}
      >
        <ReviewText />
        <div className="audit-review-split-line"></div>
        <Column height={"76vh"} overflowY="auto">
          <ReviewTable />
        </Column>
      </Row>
      <Divider />
    </Column>
  );
};

export default ModelGroundTruthReview;
